import { Button } from '@chronosphereio/chrono-ui';
import { produce } from 'immer';
import { Refresh as RefreshIcon } from 'mdi-material-ui';
import { OptionsEditorProps } from '@/plugin-system';

interface ResetSettingsButtonProps<Spec> {
  value: OptionsEditorProps<Spec>['value'];
  onChange: OptionsEditorProps<Spec>['onChange'];
}

export function ResetSettingsButton<Spec>(props: ResetSettingsButtonProps<Spec>) {
  const { value, onChange } = props;

  // Reset should set the spec to {}
  const handleResetSettings = () => {
    onChange(
      produce(value, () => {
        return {};
      })
    );
  };

  return (
    <Button variant="tertiary" StartIcon={<RefreshIcon />} sx={{ alignSelf: 'end' }} onClick={handleResetSettings}>
      Reset all settings to defaults
    </Button>
  );
}
